<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      讲师<span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>
    </div>
    <form class="class_add_con w622 col_2_1 " :style="editModeStyle" data-vv-scope="form" novalidate>
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr class="tita">
          <td colspan="2" align="left" class="left_td" style="text-align:left;">讲师基本信息</td>
        </tr>
        <tr>
          <td class="left_td pt30">姓名：</td>
          <td class="pt20"><input type="text" v-validate="'required'" v-model="form.name" name="name" placeholder="请输入姓名" class="put_495" style="width:180px;"/></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.name') }}</div>
        <tr>
          <td class="left_td">性别：</td>
          <td><input name="" type="radio" value="0" v-model="form.sex" />
            男　　
            <input name="" type="radio" value="1" v-model="form.sex" />
            女
          </td>
        </tr>
        <tr>
          <td class="left_td">学历：</td>
          <td>
            <select name="education" class="all_select" v-model="form.education">
              <option value="">选择学历</option>
              <option v-for="item in selects.education" v-bind:key="item.value" :value="item.value">{{item.label}}</option>
            </select>
          </td>
        </tr>
        <tr>
          <td class="left_td">职称：</td>
          <td><input type="text" name="textfield"  placeholder="请输入职称" class="put_495" style="width:180px;" v-model="form.title" /></td>
        </tr>
        <tr>
          <td class="left_td">手机号：</td>
          <td><input type="text" name="textfield" placeholder="请输入手机号" class="put_495" style="width:180px;" v-model="form.mobile"/></td>
        </tr>
        <tr>
          <td class="left_td " valign="top">年龄：</td>
          <td><input type="text" name="textfield" placeholder="请输入年龄" class="put_495" style="width:180px;" v-model="form.age" /></td>
        </tr>
        <tr>
          <td class="left_td">头像：</td>
          <td valign="top" class="rdiv">
            <img v-if="form.faceUrl && form.faceUrl!==''" :src="form.faceUrl"  class="upload_con" style="top: 0 !important;" />
            <UploadOSS :uploadOSSConf="uploadOSSConf" :DOM_ID="'faceUrl'" v-if="uploadOSSConf.STS!=null"  @success = "OSSUploadSuccess"></UploadOSS>
            <p class="mt10"><span class="tips_text">建议图片像素280*280或500*500，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
          </td>
        </tr>
        <tr>
          <td class="left_td pt30" valign="top">专长领域：</td>
          <td valign="top" class="pt20"><textarea name="" cols="" rows="" class="text_area w490 h70" v-model="form.master"></textarea></td>
        </tr>
        <tr>
          <td class="left_td" style="padding-top: 20px;" valign="top">工作简历：</td>
          <td valign="top" class="pt10"><textarea name="" cols="" rows="" class="text_area w490" v-model="form.content"></textarea></td>
        </tr>
      </table>
      <p class="btn_center mt50">
        <input name="" type="button" class="all_btn" value="提交完成" @click="validateForm('form')" />
      </p>
    </form>
    <!--相关课程-->
    <div v-if="isEdit" class="col_2_2 w270 teacher_right">
      <h3>讲师相关课程</h3>
      <div class="r_h520" v-if="courseList.length > 0">
        <dl v-for="item in courseList.slice(0, 3)" :key="item.id" @click="to(item.id)" style="cursor: pointer;">
          <dt>
            <img src="@/assets/images/course_default.png" v-if="!item.faceUrl || item.faceUrl == ''" />
            <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''">
          </dt>
          <dd>
            <h4>{{item.name}}</h4>
          </dd>
        </dl>
      </div>
      <div class="r_h520" v-if="courseList.length == '0'">
        <img src="@/assets/images/none_data.jpg" alt="">
      </div>
      <!--a  href="javascript:void(0);" class="t_add " @click="show1">添加讲师相关课程</a-->
    </div>
    <!--/相关课程-->
    <div class="clear"></div>
  </div>
</template>
<script>
import config from '@/config'
import api from '@/api'
import Bus from '@/utils/bus'
import utils from '@/utils'
import UploadOSS from '@/components/common/upload/uploadOSS.vue'
import CourseSelect from '@/page/byl/org/course/select.vue'
import { mapState } from 'vuex'
import '@/utils/validator.js'
export default {
  components: { UploadOSS },
  data () {
    return {
      form: {
        sex: '0',
        education: ''
      },
      selects: {
        education: []
      },
      courseList: [],
      prefix: this.$route.meta.prefix || '',
      uploadOSSConf: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null }
    }
  },
  created () {
    if (this.$route.params.id !== 'void') {
      this.getCourseListByTeacherId(this.$route.params.id)
    }
  },
  mounted () {
    this.selects.education = this.education
    if (this.isEdit) { // 通过 id 取信息并且去取相关课程
      this.getModel(this.$route.params.id)
      this.$on('data-prepared', function (data) {
        for (let i = 0; i < this.education.length; i++) {
          if (this.education[i].value == data.education) {
            this.form.education = data.education
          }
        }
      });
    }
    this.getSTS()
    this.OSSUploadSuccess()
  },
  computed: {
    ...mapState('dropdowns', ['education']),
    isEdit () {
      return this.$route.params.id && this.$route.params.id !== 'void'
    },
    editModeStyle () {
      if (!this.isEdit) { // 新增时拉大宽度
        return {
          width: '944px'
        }
      }
    }
  },
  methods: {
    to (id) {
      this.$router.push({path: this.prefix + '/org/course/' + id})
    },
    del (arr, item) {
      utils.removeObjWithArr(arr, item)
    },
    show1 () {
      var that = this
      // let excludeIds = this.createIds(this.tmpList1, '00')
      this.$modal.show(CourseSelect, {
        // ids: excludeIds
        ids: ''
      })
    },
    popup (msg) {
      this.$toasted.show(msg)
    },
    confirmBox (o) {
      var that = this
      this.$modal.show('dialog', {
        title: '提交',
        text: '确认提交吗？',
        buttons: [
          {
            title: '确认',
            default: true,
            handler: utils.debounce(() => {
              if (o.yes && o.yes instanceof Function) {
                o.yes()
                that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
              }
            }, 1000)
          },
          {
            title: '取消'
          }
        ]
      })
    },
    validateForm (scope) {
      var bus = this
      this.$validator.validateAll(scope).then(function (result) {
        if (result) {
            bus.confirmBox({
              yes: function () {
                if (bus.isEdit) { // 编辑
                  api.post(config.teacherApiPath, '/teacher/edit', bus.form, function (r) { // 正常
                    bus.popup('保存成功')
                    bus.$router.push(bus.prefix + '/org/teacherList')
                  })
                } else { // 新增
                  api.post(config.teacherApiPath, '/teacher/edit', bus.form, function (r) { // 正常
                    bus.popup('创建讲师成功')
                    bus.$router.push(bus.prefix +'/org/teacherList')
                  })
                }
              }
            })
        } else {
          bus.popup('请确保信息正确与完整')
          return false
        }
      })
    },
    getModel (id) {
      var that = this
      api.get(config.teacherApiPath, '/teacher/' + id, null, function (r) { // 正常
        that.form = r.data
        that.$emit('data-prepared', that.form)
      })
    },
    getSTS () {
      this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
        let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
        this.uploadOSSConf.STS = STS
      })
    },
    OSSUploadSuccess (r) {
      if (r && r != '') {
        this.$set(this.form, r.dom_id, r.res.requestUrls[0])
      }
    },
    getCourseListByTeacherId (id) {
      this.$api.post(this.$global.courseApiPath, '/course/teacher', {teacherId: id}, r => {
        if (r.data) {
          this.courseList = r.data
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/byl/org/teacher/model.vue